import {useTypedSelector} from "../../hooks/useTypedSelector";
import Card from "./Card";
import {useActions} from "../../hooks/useActions";
import parse from 'html-react-parser';

function CardVeryBig() {
    const {cardBigSize} = useTypedSelector(state => state.auth);
    const {setCardBigSize} = useActions();
    let className = 'cardVeryBigContainerHide';
    if (cardBigSize !== false) {
        className = 'cardVeryBigContainerVisible';
    }

    let fullText = '';
    if (cardBigSize.ability !== undefined && cardBigSize.ability !== null) {
        if (
            cardBigSize.ability.full_text !== undefined
            && cardBigSize.ability.full_text !== null
            && cardBigSize.ability.full_text !== ''
        ) {
            fullText = '<span>' + cardBigSize.ability.full_text + '</span>';
        }
    }

    return (
        <div className={'cardVeryBigContainer ' + className} onClick={() => {
            setCardBigSize(false);
        }}>

            {(cardBigSize !== false) ? (
                <div className={'cardFullContainer'}>
                    <Card card={cardBigSize} isVeryBigSize={true}/>
                    {(fullText !== '') ?
                        <div className={'cardFullTextContainer'}>
                            <div className={'cardFullText'}>{parse(fullText)}</div>
                        </div> : <div></div>
                    }
                </div>

            ) : (
                <div></div>
            )
            }

        </div>
    )
}

export default CardVeryBig